'use client'

import type { TSocialLinkField } from 'features/generator/contentFormSections'
import { socialLinkListAtom } from 'features/generator/contentFormSections'
import { TQrScreenProps } from 'features/generator/QrScreen/QrScreen'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'

import { SocialLinkItem } from './SocialLinkItem'

export const SocialSection = ({ demoMode }: TQrScreenProps) => {
	const t = useTranslations()
	const socialLinkList = useAtomValue(socialLinkListAtom)

	const demoSocialLinkList: TSocialLinkField[] = [
		{
			platformId: 'facebook',
			url: 'https://facebook.com',
			name: 'Facebook',
			description: t(
				'generator__content_form_section__social__fallback_description',
			),
		},
		{
			platformId: 'instagram',
			url: 'https://instagram.com',
			name: 'Instagram',
			description: t(
				'generator__content_form_section__social__fallback_description',
			),
		},
		{
			platformId: 'youtube',
			url: 'https://youtube.com',
			name: 'YouTube',
			description: t(
				'generator__content_form_section__social__fallback_description',
			),
		},
	]

	const socialLinksToRender =
		demoMode && socialLinkList.length === 0
			? demoSocialLinkList
			: socialLinkList

	return (
		<ul className="flex flex-col gap-1.5">
			{socialLinksToRender.map((item, index) => (
				<SocialLinkItem
					key={item.platformId}
					item={item}
					index={index}
					demoMode={demoMode}
				/>
			))}
		</ul>
	)
}
